import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { Checkbox } from "semantic-ui-react";
import LoadingSpinner from "../LoadingSpinner";
import { cityName, cityStartsWith } from "../../api/cityApi";
import {
  getByValueAndKey,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import SearchDropdown from "../input/SearchDropdown";
import Input from "../input/Input";
import Dropdown from "../input/Dropdown";
import Button from "../input/Button";
import { vehicleValidation, isInspectionDateRequired } from "../validations/vehicleCreation";
import InfoList from "../InfoList";
import { RefreshCcw, User } from "react-feather";
import {
  formatFromJsonDate,
  formatToDateOnlyFromJsonDate,
} from "../../dateConfig";
import { FORMS, MODULES } from "../../const";
import useUserCompany from "../../hooks/useUserCompany";
import { existsByDetStatusAndDetActiveAndDetDedId } from "../../api/finance/deductionMasterApi";
import { useSelector } from "react-redux";
import { syncVehicle } from "../../api/vehicleapi";
import { toast } from "react-toastify";

const FORM = FORMS.VEHICLE.VEH_DETAIL.form;

const VehicleForm = forwardRef(
  (
    {
      editMode,
      currentValues,
      errors,
      dropdown,
      isLoading,
      onOperationalStatusChange,
      onClose,
    },
    ref,
  ) => {
    const user = useSelector((state) => state.user);
    const [currentErrors, setCurrentErrors] = useState(errors);
    const driverRef = useRef();
    const helperRef = useRef();
    const userCompany = useUserCompany();
    const [company, setCompany] = useState(
      userCompany ? userCompany.comId : null,
    );

    useEffect(() => {
      setCompany(userCompany ? userCompany.comId : null);
    }, [userCompany]);

    useEffect(() => {
      setCurrentErrors(errors);
    }, [errors]);

    const hasAnyErrors = currentErrors && Object.keys(currentErrors).length > 0;

    if (hasAnyErrors) {
      document.querySelector("#vehicle-details-form")?.classList.add("error");
    } else {
      document.querySelector("#vehicle-details-form")?.classList.remove("error");
    }
    const [previousFeatures, setPreviousFeatures] = useState([]);
    useEffect(() => {
      if (editMode) {
        setPreviousFeatures(currentValues.vehicleFeatures);
      }
    }, [currentValues, editMode]);

    console.log("vehicleForm", currentValues);

    const [initialActive, setInitialActive] = useState(
      editMode ? currentValues?.vehActive : 1,
    );
    const formatDateForInput = (dateString) => {
      if (!dateString) return "";

      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    };

    const [vehicle, setVehicle] = useState(
      editMode
        ? {
            ...currentValues,
            vehComId: company,
            vehAgreement: currentValues.vehAgreementId,
            vehTransporter: currentValues.vehTransporterId,
            vehManufacturer: currentValues.vehManufacturerId,
            vehModel: currentValues.vehModelId,
            vehTyreSize: currentValues.vehTyreSizeId,
            vehBasedDriver: currentValues.vehBasedDriverId,
            vehHelper: currentValues.vehHelperId,
            vehBasedCompany: currentValues.vehBasedCompanyId,
            vehBasedCity: currentValues.vehBasedCityId,
            vehCommitementDateFrom:
              currentValues.vehCommitment === 2
                ? ""
                : currentValues.vehCommitementDateFrom,
            vehCommitementDateTo:
              currentValues.vehCommitment === 2
                ? ""
                : currentValues.vehCommitementDateTo,
            vehInsuranceExpire: formatDateForInput(
              currentValues.vehInsuranceExpire,
            ),
            vehFeatures: currentValues.vehicleFeatures
              ? currentValues.vehicleFeatures.map(
                  (item) => item.vfeVehicleFeature,
                )
              : [],
            vehGpsTracking: currentValues.vehGpsTracking || "",
          }
        : {
            vehFeatures: [],
            vehVehicleNo: "",
            vehCode: "",
            vehReference: "",
            vehAgreement: "",
            vehRemarks: "",
            vehTransporter: "",
            vehBasedDriver: "",
            vehHelper: "",
            vehBasedCity: "",
            vehBasedCompany: "",
            vehAvailable: false,
            vehNextAvailableDate: "",
            vehGpsKey: "",
            vehGpsProvider: "",
            vehGpsReference: "",
            vehGpsTracking: "",
            vehStatus: 2,
            vehActive: 1,
            vehComId: company,
            vehDescription: "",
            vehChassisNo: "",
            vehEngineNo: "",
            vehBookRegNo: "",
            vehFuelConsumption: "",
            vehFuelType: "",
            vehManufacturer: "",
            vehModel: "",
            vehTyreSize: "",
            vehYearManufacturer: "",
            vehYearRegister: "",
            vehBodyType: "",
            vehNoOfTyres: "",
            vehEngineCapacity: "",
            vehWidth: "",
            vehLength: "",
            vehHeight: "",
            vehSizeUom: "",
            vehSealPoints: "",
            vehInspectionTime: "",
            vehCommitment: 2,
            vehCommitmentDateFrom: "",
            vehCommitmentDateTo: "",
            vehInspectionGroup: "",
            vehBrandedDate: "",
            vehRateType: "",
            vehAgreedValue: "",
            vehAgreedUnit: "",
            vehAgreedDate: "",
            vehOperationalStatus: "",
            vehLastServiceDate: "",
            vehNextInspectionDate: "",
            vehInsuranceProvider: "",
            vehInsuranceCoverage: "",
            vehInsuranceExpire: "",
          },
    );

    const [available, setAvailable] = useState(false);
    useEffect(() => {
      setAvailable(vehicle.vehAvailable);
    }, [vehicle.vehAvailable]);
    const [searchFieldReset, setSearchFieldReset] = useState(false);

    const [cityList, setCityList] = useState([]);
    const [citySearchLoading, setCitySearchLoading] = useState(false);
    const [currentCityValue, setCurrentCityValue] = useState("");
    const [buttonClicked, setButtonClicked] = useState(false);
    const [isSyncing, setIsSyncing] = useState(false);
    const [gpsRef,setGpsRef] = useState(editMode ? currentValues.vehGpsReference : '');

    useEffect(() => {
      (async () => {
        if (editMode) {
          setCitySearchLoading(true);
          const city = await cityName(vehicle.vehBasedCity);
          setCurrentCityValue(city);
          setCitySearchLoading(false);
        }
      })();
    }, [vehicle.vehBasedCity, editMode]);

    useImperativeHandle(ref, () => ({
      // Expose the function to the parent component
      getData: async () => {
        if (editMode) {
          const addedValues = vehicle.vehFeatures.filter(
            (item) =>
              !previousFeatures.some(
                (feature) => feature.vfeVehicleFeature === item,
              ),
          );

          const deletedValues = previousFeatures.filter(
            (item) => !vehicle.vehFeatures.includes(item.vfeVehicleFeature),
          );

          const created = [];

          for (let featureId of addedValues) {
            const vehicleFeature = await getByValueAndKey(
              "vehicle_feature",
              featureId,
            );

            const objectFeature = {
              vfeCode: vehicleFeature.keyCode,
              vfeVehicleFeature: vehicleFeature.keyId,
              vfeDescription: vehicleFeature.keyDescription,
              vfeSeq: vehicleFeature.keySeq,
              vfeStatus: 2,
              vfeActive: vehicleFeature.keyActive,
            };
            created.push(objectFeature);
          }

          const deleted = deletedValues.map((item) => item.vfeId);

          return {
            ...vehicle,
            vehicleFeatureRequests: {
              created,
              deleted,
              modified: [],
            },
          };
        } else {
          const vehicleFeatureRequests = [];
          for (let vehicleFeatureId of vehicle.vehFeatures) {
            const vehicleFeature = await getByValueAndKey(
              "vehicle_feature",
              vehicleFeatureId,
            );

            const objectFeature = {
              vfeCode: vehicleFeature.keyCode,
              vfeVehicleFeature: vehicleFeature.keyId,
              vfeDescription: vehicleFeature.keyDescription,
              vfeSeq: vehicleFeature.keySeq,
              vfeStatus: 2,
              vfeActive: vehicleFeature.keyActive,
            };

            vehicleFeatureRequests.push(objectFeature);
          }
          return {
            ...vehicle,
            vehicleFeatureRequests,
          };
        }
      },
      isDeletedActive: () => vehicle.vehActive === 2 && initialActive !== 2,
      resetForm: () => {
        setButtonClicked(true);
      },
      validateForm: () => {
        return vehicleValidation(vehicle, dropdown?.inspectionTimeOpt);
      },
    }));

    const handleSearchChange = async (e, data) => {
      setCurrentCityValue(data.value);
      if (data.value.length > 3) {
        setCitySearchLoading(true);
        const response = await cityStartsWith(data.value);
        setCityList(response);
        setCitySearchLoading(false);
      }
    };

    const vehicleFeatureSelect = async (e, data) => {
      setVehicle((prev) => ({
        ...prev,
        vehFeatures: data.value,
      }));
    };

    useEffect(() => {
      if (buttonClicked) {
        setVehicle({
          vehFeatures: [],
          vehVehicleNo: "",
          vehCode: "",
          vehReference: "",
          vehAgreement: "",
          vehRemarks: "",
          vehTransporter: "",
          vehBasedDriver: "",
          vehHelper: "",
          vehBasedCity: "",
          vehBasedCompany: "",
          vehAvailable: false,
          vehNextAvailableDate: "",
          vehGpsKey: "",
          vehGpsProvider: "",
          vehGpsReference: "",
          vehGpsTracking: "",
          vehStatus: 2,
          vehActive: 1,

          vehComId: company, //doesn't appear in front end
          vehDescription: "",
          vehChassisNo: "",
          vehEngineNo: "",
          vehBookRegNo: "",
          vehFuelConsumption: "",
          vehFuelType: "",
          vehManufacturer: "",
          vehModel: "",
          vehTyreSize: "",
          vehYearManufacturer: "",
          vehYearRegister: "",
          vehBodyType: "",
          vehNoOfTyres: "",
          vehEngineCapacity: "",

          vehWidth: "",
          vehLength: "",
          vehHeight: "",
          vehSizeUom: "",
          vehSealPoints: "",
          vehInspectionTime: "",
          vehCommitment: 2,
          vehCommitmentDateFrom: "",
          vehCommitmentDateTo: "",
          vehInspectionGroup: "",
          vehBrandedDate: "",
          vehRateType: "",
          vehAgreedValue: "",
          vehAgreedUnit: "",
          vehAgreedDate: "",
          vehOperationalStatus: "",
          vehLastServiceDate: "",
          vehNextInspectionDate: "",
          vehInsuranceProvider: "",
          vehInsuranceCoverage: "",
          vehInsuranceExpire: "",
        });
        setSearchFieldReset(true);
        setCurrentErrors({});
        setButtonClicked(false);
      }
    }, [buttonClicked]);

    useEffect(() => {
      if (vehicle.vehCommitment === 2) {
        setVehicle((prev) => ({
          ...prev,
          vehCommitmentDateFrom: "",
          vehCommitmentDateTo: "",
        }));
      }
    }, [vehicle.vehCommitment]);

    const manualSyncVehicle = async () => {
      setIsSyncing(true);
      const payload = {
        vehicleNo: vehicle.vehVehicleNo,
        gpsTrackingNo: vehicle.vehGpsTracking,
        username: user.username,
        company: company,
      };

      const response = await syncVehicle(payload);

      const [status, message] = response.split("|");

      if (status === "DUPLICATE") {
        toast.warn(message, {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSyncing(false);
        return;
      }

      if (status === "SUCCESS") {
        toast.success(message, {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSyncing(false);
        onClose();
        return;
      }

      toast.error(message || "Vehicle sync failed.", {
        autoClose: 5000,
        containerId: "Main",
      });
      setIsSyncing(false);
    };

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            id="vehicle-details-form"
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">Features</h4>
              <Dropdown
                label="Select Features"
                error={currentErrors.vehFeatures}
                editMode={editMode}
                module={MODULES.Master}
                form={FORM}
                field="veh_features"
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { vehFeatures: _, ...rest } = prevState;
                    return rest;
                  })
                }
                multiple={true}
                options={dropdown.featureDropdown}
                placeholder="Select Features"
                style={{ height: "20px" }}
                value={vehicle.vehFeatures}
                onChange={vehicleFeatureSelect}
              />
            </div>

            <div className="ui segment">
              <h4 className="ui dividing header">
                Vehicle Registration Details
              </h4>
              <div className="two fields">
                <Input
                  required={true}
                  label="Veh. No"
                  companyWise={true}
                  companyCol="veh_com_id"
                  activeCol="veh_active"
                  error={currentErrors.vehVehicleNo}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_vehicleno"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehVehicleNo: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="vehNo"
                  placeholder="Veh. No"
                  value={vehicle.vehVehicleNo}
                  onChange={(e) => {
                    setVehicle((prev) => ({
                      ...prev,
                      vehVehicleNo: e.target.value,
                    }));
                  }}
                  minLength={4}
                  duplicate={false}
                  tableName="masterdata.tms_m_vehicle_details"
                  primaryKey="veh_id"
                  searchField="veh_vehicleno"
                  keyType="S"
                  duplicateErrorMessage="This vehicle number already exists"
                  setErrors={setCurrentErrors}
                  errorField="vehVehicleNo"
                  id={vehicle.vehId}
                />

                <Input
                  label="Veh. Code"
                  error={currentErrors.vehCode}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_code"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="vehCode"
                  placeholder="Veh. Code"
                  disabled
                  value={vehicle.vehCode}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehCode: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="two fields">
                <Input
                  label="Veh. Reference(For 3rd party soft)"
                  error={currentErrors.vehReference}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_reference"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehReference: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="vehReference"
                  placeholder="Veh. Reference"
                  value={vehicle.vehReference}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehReference: e.target.value,
                    }))
                  }
                />

                <SearchDropdown
                  key={1}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_agreement"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehAgreement: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehAgreement: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "agreement",
                    value: "",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_agreements",
                    primaryKey: "agr_id",
                    fieldName: "agr_name",
                    id: vehicle.vehAgreement,
                  }}
                  label="Agreement"
                  error={currentErrors.vehAgreement}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehAgreement: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
              </div>
              <div className="two fields">
                <Input
                  label="Remarks"
                  error={currentErrors.vehRemarks}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_remarks"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehRemarks: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="remarks"
                  placeholder="Remarks"
                  value={vehicle.vehRemarks}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehRemarks: e.target.value,
                    }))
                  }
                />

                <SearchDropdown
                  key={1}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_transporter"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehTransporter: null,
                      vehBasedDriver: null,
                      vehHelper: null,
                    }));
                    driverRef.current.reset();
                    helperRef.current.reset();
                  }}
                  onResultSelect={(data) => {
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehTransporter: data,
                      vehBasedDriver: null,
                      vehHelper: null,
                    }));
                    driverRef.current.reset();
                    helperRef.current.reset();
                  }}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Transporter",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_stakeholder",
                    primaryKey: "stk_id",
                    fieldName: "stk_name",
                    id: vehicle.vehTransporter,
                  }}
                  required={true}
                  label="Transporter"
                  error={currentErrors.vehTransporter}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehTransporter: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  ref={driverRef}
                  disabled={!vehicle.vehTransporter}
                  key={1}
                  threshold={1}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_based_driver"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehBasedDriver: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehBasedDriver: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "employee",
                    value: "Driver",
                    param1: vehicle.vehTransporter?.toString(),
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_employee",
                    primaryKey: "emp_id",
                    fieldName: "emp_fullname",
                    id: vehicle.vehBasedDriver,
                  }}
                  required={true}
                  label="Base Driver"
                  error={currentErrors.vehBasedDriver}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehBasedDriver: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />

                <SearchDropdown
                  ref={helperRef}
                  key={1}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_helper"
                  disabled={!vehicle.vehTransporter}
                  threshold={1}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehHelper: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehHelper: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "employee",
                    value: "Helper",
                    param1: vehicle.vehTransporter?.toString(),
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_employee",
                    primaryKey: "emp_id",
                    fieldName: "emp_fullname",
                    id: vehicle.vehHelper,
                  }}
                  label="Helper"
                  error={currentErrors.vehHelper}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehHelper: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  key={1}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_based_city"
                  required={true}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehBasedCity: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehBasedCity: data,
                    }))
                  }
                  api={cityStartsWith}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_reg_cities",
                    primaryKey: "cit_id",
                    fieldName: "cit_city",
                    id: vehicle.vehBasedCity,
                  }}
                  label="Base location"
                  error={currentErrors.vehBasedCity}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehBasedCity: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />

                <SearchDropdown
                  key={1}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_based_company"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehBasedCompany: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehBasedCompany: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Customer",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_stakeholder",
                    primaryKey: "stk_id",
                    fieldName: "stk_name",
                    id: vehicle.vehBasedCompany,
                  }}
                  label="Base Company"
                  error={currentErrors.vehBasedCompany}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehBasedCompany: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
              </div>
              <div className="two fields">
                <div
                  style={{ display: "flex", flexDirection: "column" }}
                  className={`field ${
                    currentErrors.vehAvailable ? "error" : ""
                  }`}
                >
                  <label>Availability</label>
                  <Checkbox
                    type="checkbox"
                    name="availability"
                    placeholder="Availability"
                    editMode={editMode}
                    module={MODULES.Master}
                    form={FORM}
                    field="veh_available"
                    checked={vehicle.vehAvailable}
                    onChange={() => {
                      const newValue = !vehicle.vehAvailable;
                      setVehicle((prev) => ({
                        ...prev,
                        vehAvailable: newValue,
                        vehNextAvailableDate: newValue
                          ? ""
                          : prev.vehNextAvailableDate,
                      }));
                    }}
                  />
                  <small style={{ color: "#9f3a38" }}>{`${
                    currentErrors.vehAvailable ? currentErrors.vehAvailable : ""
                  }`}</small>
                </div>
                <Input
                  label="Next Available Date"
                  error={currentErrors.vehNextAvailableDate}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_next_available_date"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehNextAvailableDate: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="available_date"
                  placeholder="Next Available Date"
                  value={vehicle.vehNextAvailableDate}
                  min={formatToDateOnlyFromJsonDate(new Date())}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehNextAvailableDate: e.target.value,
                    }))
                  }
                  disabled={available}
                />
              </div>
              <div className="two fields">
                <Input
                  label="GPS Key"
                  error={currentErrors.vehGpsKey}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_gps_key"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehGpsKey: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="gpsKey"
                  placeholder="GPS Key"
                  value={vehicle.vehGpsKey}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehGpsKey: e.target.value,
                    }))
                  }
                />

                <SearchDropdown
                  key={1}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_gps_provider"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehGpsProvider: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehGpsProvider: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Supplier",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_stakeholder",
                    primaryKey: "stk_id",
                    fieldName: "stk_name",
                    id: vehicle.vehGpsProvider,
                  }}
                  label="GPS Provider"
                  error={currentErrors.vehGpsProvider}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehGpsProvider: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
              </div>
              <div className="two fields">
                {/* <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    // width: "50%",
                  }}
                > */}
                <Input
                  style={{ width: "40%" }}
                  label="GPS Reference"
                  error={currentErrors.vehGpsReference}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_gps_reference"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehGpsReference: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="gpsReference"
                  placeholder="GPS Reference"
                  value={vehicle.vehGpsReference}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehGpsReference: e.target.value,
                    }))
                  }
                />
                <Button
                  style={{ marginTop: "22px", marginRight: "10px" }}
                  Icon={RefreshCcw}
                  label={"Sync"}
                  disabled={
                    editMode &&
                    gpsRef &&
                    gpsRef !== ""
                  }
                  isLoading={isSyncing}
                  onClick={manualSyncVehicle}
                />

                <Input
                  label="GPS Tracking Name"
                  error={currentErrors.vehGpsTracking}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_gps_tracking"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehGpsTracking: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="gpsTracking"
                  placeholder="GPS Tracking Name"
                  value={vehicle.vehGpsTracking}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehGpsTracking: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={false}
                  label="Commitment"
                  clearable={false}
                  // error={currentErrors.vehStatus}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_commitment"
                  // resetError={() =>
                  //   setCurrentErrors((prevState) => {
                  //     const { vehStatus: _, ...rest } = prevState;
                  //     return rest;
                  //   })
                  // }
                  options={dropdown.yesNoOpt}
                  placeholder="Status"
                  style={{ height: "20px" }}
                  value={vehicle.vehCommitment}
                  onChange={(e, data) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehCommitment: data.value,
                      vehCommitmentDateFrom:
                        data.value === 2 ? "" : prev.vehCommitmentDateFrom,
                      vehCommitmentDateTo:
                        data.value === 2 ? "" : prev.vehCommitmentDateTo,
                    }))
                  }
                />
              </div>
              <div className="two fields">
                <Input
                  label="Commitment From Date"
                  error={currentErrors.vehCommitmentDateFrom}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_commitment_date_from"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehCommitmentDateFrom: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="vehCommitmentDateFrom"
                  placeholder="from date"
                  value={
                    vehicle.vehCommitmentDateFrom
                      ? formatToDateOnlyFromJsonDate(
                          vehicle.vehCommitmentDateFrom,
                        )
                      : ""
                  }
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehCommitmentDateFrom:
                        vehicle.vehCommitment === 2 ? "" : e.target.value,
                    }))
                  }
                  disabled={vehicle.vehCommitment === 2}
                />
                <Input
                  label="Commitment To Date"
                  error={currentErrors.vehCommitmentDateTo}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_commitment_date_to"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehCommitmentDateTo: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="vehCommitmentDateTo"
                  placeholder="to date"
                  value={
                    vehicle.vehCommitmentDateTo
                      ? formatToDateOnlyFromJsonDate(
                          vehicle.vehCommitmentDateTo,
                        )
                      : ""
                  }
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehCommitmentDateTo:
                        vehicle.vehCommitment === 2 ? "" : e.target.value,
                    }))
                  }
                  disabled={vehicle.vehCommitment === 2}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Vehicle Status"
                  error={currentErrors.vehOperationalStatus}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_operational_status"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehOperationalStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.vehAuthorizedOpt}
                  placeholder="vehicle status"
                  style={{ height: "20px" }}
                  value={vehicle.vehOperationalStatus}
                  onChange={(e, data) => {
                    setVehicle((prev) => ({
                      ...prev,
                      vehOperationalStatus: data.value,
                    }));
                    if (onOperationalStatusChange) {
                      onOperationalStatusChange(data.value);
                    }
                  }}
                />
                <Dropdown
                  label="Vehicle Rate Type"
                  error={currentErrors.vehRateType}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_rate_type"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehRateType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.vehRateTypeOpt}
                  placeholder="rate type"
                  style={{ height: "20px" }}
                  value={vehicle.vehRateType}
                  onChange={(e, data) =>
                    setVehicle((prev) => ({ ...prev, vehRateType: data.value }))
                  }
                />
              </div>
              <div className="two fields">
                <Input
                  label="Vehicle Branded Date"
                  error={currentErrors.vehBrandedDate}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_branded_date"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehBrandedDate: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="vehBrandedDate"
                  placeholder="branded date"
                  value={vehicle.vehBrandedDate ? formatToDateOnlyFromJsonDate(vehicle.vehBrandedDate) : ""}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehBrandedDate: e.target.value,
                    }))
                  }
                />
                <Input
                  label="Agreed Date"
                  error={currentErrors.vehAgreedDate}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_branded_date"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehAgreedDate: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="vehAgreedDate"
                  placeholder="agreed date"
                  value={vehicle.vehAgreedDate ? formatToDateOnlyFromJsonDate(vehicle.vehAgreedDate) : ""}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehAgreedDate: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="two fields">
                <Input
                  label="Agreed Value"
                  error={currentErrors.vehAgreedValue}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_agreed_value"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehAgreedValue: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="number"
                  step="0.0001"
                  min={0}
                  name="value"
                  placeholder="value"
                  value={vehicle.vehAgreedValue}
                  onChange={(e) => {
                    const value = e.target.value;
                    const Regex = /^\d*\.?\d{0,4}$/;
                    if (Regex.test(value) || value === "") {
                      setVehicle((prev) => ({
                        ...prev,
                        vehAgreedValue: e.target.value,
                      }));
                    } else {
                      return;
                    }
                  }}
                />
                <Dropdown
                  label="Agreed Unit"
                  error={currentErrors.vehAgreedUnit}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_agreed_unit"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehAgreedUnit: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.vetUOMOpt}
                  style={{ height: "20px" }}
                  placeholder="units"
                  value={vehicle.vehAgreedUnit}
                  onChange={(e, data) =>
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehAgreedUnit: data.value,
                    }))
                  }
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Status"
                  error={currentErrors.vehStatus}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_status"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.specialStatusOpt}
                  placeholder="Status"
                  style={{ height: "20px" }}
                  value={vehicle.vehStatus}
                  onChange={(e, data) =>
                    setVehicle((prev) => ({ ...prev, vehStatus: data.value }))
                  }
                />
                <Dropdown
                  required={true}
                  label="Active"
                  error={currentErrors.vehActive}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_active"
                  authenticated={true}
                  needDeletePermission={true}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.activeOpt}
                  style={{ height: "20px" }}
                  placeholder="Active"
                  value={vehicle.vehActive}
                  onChange={(e, data) =>
                    setVehicle((prev) => ({ ...prev, vehActive: data.value }))
                  }
                />
              </div>
            </div>

            <div className="ui segment">
              <h4 className="ui dividing header">Vehicle Details</h4>
              <div className="two fields">
                <Input
                  label="Description"
                  error={currentErrors.vehDescription}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_description"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehDescription: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="description"
                  placeholder="Description"
                  value={vehicle.vehDescription}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehDescription: e.target.value,
                    }))
                  }
                />
                <Input
                  label="Chassis No"
                  error={currentErrors.vehChassisNo}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_chassisno"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehChassisNo: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="chassisNo"
                  placeholder="Chassis No"
                  value={vehicle.vehChassisNo}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehChassisNo: e.target.value,
                    }))
                  }
                  minLength={8}
                />
              </div>
              <div className="two fields">
                <Input
                  label="Eng. No"
                  error={currentErrors.vehEngineNo}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_engine_no"
                  companyWise={true}
                  companyCol="veh_com_id"
                  activeCol="veh_active"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehEngineNo: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="engNo"
                  placeholder="Eng. No"
                  value={vehicle.vehEngineNo}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehEngineNo: e.target.value,
                    }))
                  }
                  minLength={8}
                  duplicate={false}
                  tableName="masterdata.tms_m_vehicle_details"
                  primaryKey="veh_id"
                  searchField="veh_engine_no"
                  keyType="S"
                  duplicateErrorMessage="This engine number already exists"
                  setErrors={setCurrentErrors}
                  errorField="vehEngineNo"
                  id={vehicle.vehId}
                />
                <Input
                  required={true}
                  label="Book. Reg. No"
                  error={currentErrors.vehBookRegNo}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_book_reg_no"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehBookRegNo: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="bookRegNo"
                  placeholder="Book. Reg. No"
                  value={vehicle.vehBookRegNo}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehBookRegNo: e.target.value,
                    }))
                  }
                  minLength={5}
                />
              </div>
              <div className="two fields">
                <Input
                  label="Fuel Consumption"
                  error={currentErrors.vehFuelConsumption}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_fuel_consumption"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehFuelConsumption: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="fuelConsumption"
                  placeholder="Fuel Consumption"
                  value={vehicle.vehFuelConsumption}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehFuelConsumption: e.target.value,
                    }))
                  }
                  min={4}
                  minLength={1}
                />
                <Dropdown
                  label="Fuel Type"
                  error={currentErrors.vehFuelType}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_fuel_type"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehFuelType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.fuelTypeOpt}
                  placeholder="Fuel Type"
                  style={{ height: "20px" }}
                  value={vehicle.vehFuelType}
                  onChange={(e, data) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehFuelType: data.value,
                    }))
                  }
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  key={1}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_manufacturer"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehManufacturer: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehManufacturer: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "manufacturer",
                    value: "",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_manufacturer",
                    primaryKey: "mnu_id",
                    fieldName: "mnu_manufacturer",
                    id: vehicle.vehManufacturer,
                  }}
                  label="Manufacturer"
                  error={currentErrors.vehManufacturer}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehManufacturer: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />

                <SearchDropdown
                  key={1}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_model"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehModel: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehModel: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "vehicle_model",
                    value: "",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_model",
                    primaryKey: "mod_id",
                    fieldName: "mod_model",
                    id: vehicle.vehModel,
                  }}
                  label="Model"
                  error={currentErrors.vehModel}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehModel: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
              </div>
              <div className="two fields">
                <Dropdown
                  label="Tyre Size"
                  error={currentErrors.vehTyreSize}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_tyre_size"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehTyreSize: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.tyreSizeOpt}
                  style={{ height: "20px" }}
                  placeholder="Tyre Size"
                  value={vehicle.vehTyreSize}
                  onChange={(e, data) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehTyreSize: data.value,
                    }))
                  }
                />
                <Input
                  label="Year Manu."
                  error={currentErrors.vehYearManufacturer}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_year_manufacturer"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehYearManufacturer: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="number"
                  name="manufacture_date"
                  min={0}
                  placeholder="Year Manu"
                  value={vehicle.vehYearManufacturer}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehYearManufacturer: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="two fields">
                <Input
                  label="Year Reg."
                  error={currentErrors.vehYearRegister}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_year_register"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehYearRegister: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="number"
                  name="reg_date"
                  min={0}
                  placeholder="Year Reg"
                  value={vehicle.vehYearRegister}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehYearRegister: e.target.value,
                    }))
                  }
                />
                <Dropdown
                  label="Body Type"
                  error={currentErrors.vehBodyType}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_body_type"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehBodyType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.bodyTypeOpt}
                  placeholder="Body Type"
                  style={{ height: "20px" }}
                  value={vehicle.vehBodyType}
                  onChange={(e, data) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehBodyType: data.value,
                    }))
                  }
                />
              </div>
              <div className="two fields">
                <Input
                  label="No of Tyres"
                  error={currentErrors.vehNoOfTyres}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_no_of_tyres"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehNoOfTyres: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="number"
                  name="noOfTyres"
                  placeholder="No of Tyres"
                  value={vehicle.vehNoOfTyres}
                  onChange={(e) => {
                    const value = e.target.value;
                    const Regex = /^\d*\.?\d?$/;
                    if (Regex.test(value) || value === "") {
                      setVehicle((prev) => ({
                        ...prev,
                        vehNoOfTyres: e.target.value,
                      }));
                    } else {
                      return;
                    }
                  }}
                  min={0}
                />
                <Input
                  label="Eng. Capacity"
                  error={currentErrors.vehEngineCapacity}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_engine_capacity"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehEngineCapacity: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="number"
                  name="engCapacity"
                  placeholder="Eng. Capacity"
                  value={vehicle.vehEngineCapacity}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehEngineCapacity: e.target.value,
                    }))
                  }
                  min={0}
                />
              </div>

              <div className="ui segment">
                <h4 className="ui dividing header">Cabin Measurements</h4>
                <div className="four fields">
                  <Input
                    label="Width"
                    error={currentErrors.vehWidth}
                    editMode={editMode}
                    module={MODULES.Master}
                    form={FORM}
                    field="veh_width"
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { vehWidth: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    type="number"
                    step="0.001"
                    name="width"
                    placeholder="Width"
                    value={vehicle.vehWidth}
                    onChange={(e) => {
                      const value = e.target.value;
                      const Regex = /^\d*\.?\d?$/;
                      if (Regex.test(value) || value === "") {
                        setVehicle((prev) => ({
                          ...prev,
                          vehWidth: e.target.value,
                        }));
                      } else {
                        return;
                      }
                    }}
                    min={0}
                  />
                  <Input
                    label="Length"
                    error={currentErrors.vehLength}
                    editMode={editMode}
                    module={MODULES.Master}
                    form={FORM}
                    field="veh_length"
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { vehLength: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    type="number"
                    step="0.001"
                    name="length"
                    placeholder="Length"
                    value={vehicle.vehLength}
                    onChange={(e) => {
                      const value = e.target.value;
                      const Regex = /^\d*\.?\d?$/;
                      if (Regex.test(value) || value === "") {
                        setVehicle((prev) => ({
                          ...prev,
                          vehLength: e.target.value,
                        }));
                      } else {
                        return;
                      }
                    }}
                    min={0}
                  />
                  <Input
                    label="Height"
                    error={currentErrors.vehHeight}
                    editMode={editMode}
                    module={MODULES.Master}
                    form={FORM}
                    field="veh_height"
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { vehHeight: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    type="number"
                    step="0.001"
                    name="height"
                    placeholder="Height"
                    value={vehicle.vehHeight}
                    onChange={(e) => {
                      const value = e.target.value;
                      const Regex = /^\d*\.?\d?$/;
                      if (Regex.test(value) || value === "") {
                        setVehicle((prev) => ({
                          ...prev,
                          vehHeight: e.target.value,
                        }));
                      } else {
                        return;
                      }
                    }}
                    min={0}
                  />
                  <Dropdown
                    label="Unit of Measurements"
                    error={currentErrors.vehSizeUom}
                    editMode={editMode}
                    module={MODULES.Master}
                    form={FORM}
                    field="veh_size_uom"
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { vehSizeUom: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    options={dropdown.sizeUOMOpt}
                    placeholder="UOM"
                    style={{ height: "20px" }}
                    value={vehicle.vehSizeUom}
                    onChange={(e, data) =>
                      setVehicle((prev) => ({
                        ...prev,
                        vehSizeUom: data.value,
                      }))
                    }
                  />
                </div>
              </div>
              <div className="two fields">
                <Input
                  label="Num. of Seal Points"
                  error={currentErrors.vehSealPoints}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_seal_points"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehSealPoints: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="number"
                  name="numOfSealPoints"
                  placeholder="Num. of Seal Points"
                  value={vehicle.vehSealPoints}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehSealPoints: e.target.value,
                    }))
                  }
                  min={0}
                />
                <Dropdown
                  required={false}
                  label="Insurance Coverage"
                  error={currentErrors.vehInsuranceCoverage}
                  module={MODULES.Master}
                  form={FORM}
                  clearable={true}
                  field="veh_insurance_coverage"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehInsuranceCoverage: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  onClear={() => {
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehInsuranceCoverage: -1,
                    }));
                  }}
                  placeholder="Insurance Coverage"
                  options={dropdown.inscoverageOpt}
                  value={vehicle.vehInsuranceCoverage}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehInsuranceCoverage: data.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Inspection Period"
                  error={currentErrors.vehInspectionTime}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_inspection_time"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehInspectionTime: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.inspectionTimeOpt}
                  style={{ height: "20px" }}
                  placeholder="Inspection Time"
                  value={vehicle.vehInspectionTime}
                  onChange={(e, data) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehInspectionTime: data.value,
                    }))
                  }
                />
                <Dropdown
                  label="Inspection Group"
                  error={currentErrors.vehInspectionGroup}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_status"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehInspectionGroup: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.inspecGroupOpt}
                  placeholder="inspection group"
                  style={{ height: "20px" }}
                  value={vehicle.vehInspectionGroup}
                  onChange={(e, data) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehInspectionGroup: data.value,
                    }))
                  }
                />
              </div>
              <div className="two fields">
                <Input
                  required={isInspectionDateRequired(vehicle.vehInspectionTime, dropdown?.inspectionTimeOpt)}
                  label="Last Inspection Date"
                  error={currentErrors.vehLastServiceDate}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_last_service_date"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehLastServiceDate: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="vehLastServiceDate"
                  placeholder="last service date"
                  value={vehicle.vehLastServiceDate ? formatToDateOnlyFromJsonDate(vehicle.vehLastServiceDate) : ""}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehLastServiceDate: e.target.value,
                    }))
                  }
                />
                <Input
                  required={isInspectionDateRequired(vehicle.vehInspectionTime, dropdown?.inspectionTimeOpt)}
                  label="Next Inspection Date"
                  error={currentErrors.vehNextInspectionDate}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_next_inspection_date"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehNextInspectionDate: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="vehNextInspectionDate"
                  placeholder="next inspection date"
                  value={vehicle.vehNextInspectionDate ? formatToDateOnlyFromJsonDate(vehicle.vehNextInspectionDate) : ""}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehNextInspectionDate: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  key={1}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_insurance_provider"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehInsuranceProvider: -1,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setVehicle((prevState) => ({
                      ...prevState,
                      vehInsuranceProvider: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Supplier",
                    param1: "Insurance Provider",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_stakeholder",
                    primaryKey: "stk_id",
                    fieldName: "stk_name",
                    id: vehicle.vehInsuranceProvider,
                  }}
                  error={currentErrors.vehInsuranceProvider}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehInsuranceProvider: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  label="Insurance Provider"
                />
                <Input
                  required={true}
                  label="Insurance Expire Date"
                  error={currentErrors.vehInsuranceExpire}
                  module={MODULES.Master}
                  form={FORM}
                  field="veh_insurance_expire"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehInsuranceExpire: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="vehInsuranceExpire"
                  placeholder="Insurance Expire Date"
                  value={formatDateForInput(vehicle.vehInsuranceExpire)}
                  onChange={(e) =>
                    setVehicle((prev) => ({
                      ...prev,
                      vehInsuranceExpire: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
            {editMode && (
              <InfoList
                title="User Information"
                content={[
                  {
                    title: "Created By",
                    value: vehicle.createdBy ? vehicle.createdBy : "N/A",
                  },
                  {
                    title: "Created Date",
                    value: vehicle.createdDate
                      ? formatFromJsonDate(vehicle.createdDate)
                      : "N/A",
                  },
                  {
                    title: "Last Modified By",
                    value: vehicle.lastModifiedBy
                      ? vehicle.lastModifiedBy
                      : "N/A",
                  },
                  {
                    title: "Last Modified Date",
                    value: vehicle.lastModifiedDate
                      ? formatFromJsonDate(vehicle.lastModifiedDate)
                      : "N/A",
                  },
                ]}
                Icon={User}
              />
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              <Button
                template="reset"
                onClick={(e) => {
                  setButtonClicked(true);
                }}
              />
            </div>
          </form>
        )}
      </>
    );
  },
);

export default VehicleForm;
